(() => {
  const body = document.body;
  const drawer = document.querySelector("[data-cart-drawer]");
  const backdrop = document.querySelector(".sv-drawer-backdrop");
  const menu = document.querySelector("[data-mobile-menu]");
  const toast = document.querySelector("[data-toast]");

  const money = (cents) => {
    const currency = window.Shopify?.currency?.active || "EUR";
    return new Intl.NumberFormat(document.documentElement.lang || "fr-FR", {
      style: "currency",
      currency,
    }).format(cents / 100);
  };

  const lock = () => body.classList.add("is-locked");
  const unlock = () => {
    if (!drawer?.classList.contains("is-open") && !menu?.classList.contains("is-open")) {
      body.classList.remove("is-locked");
    }
  };

  const openCart = () => {
    drawer?.classList.add("is-open");
    backdrop?.classList.add("is-open");
    drawer?.setAttribute("aria-hidden", "false");
    lock();
  };

  const closeCart = () => {
    drawer?.classList.remove("is-open");
    backdrop?.classList.remove("is-open");
    drawer?.setAttribute("aria-hidden", "true");
    unlock();
  };

  const showToast = () => {
    toast?.classList.add("is-visible");
    window.setTimeout(() => toast?.classList.remove("is-visible"), 2200);
  };

  const renderCart = (cart) => {
    document.querySelectorAll("[data-cart-count]").forEach((node) => {
      node.textContent = node.closest(".sv-cart-button")
        ? String(cart.item_count).padStart(2, "0")
        : String(cart.item_count);
    });

    const content = document.querySelector("[data-cart-content]");
    const footer = document.querySelector("[data-cart-footer]");
    if (!content || !footer) return;

    if (!cart.items.length) {
      content.innerHTML = `
        <div class="sv-empty-cart">
          <p>Votre panier est vide.</p>
          <button type="button" data-cart-close>Découvrir le drop</button>
        </div>`;
      footer.hidden = true;
    } else {
      content.innerHTML = cart.items
        .map(
          (item, index) => `
          <div class="sv-cart-item" data-line="${index + 1}">
            ${item.image ? `<img src="${item.image}" alt="">` : ""}
            <div>
              <h3>${item.product_title}</h3>
              <p>${item.variant_title || ""} · Qté ${item.quantity}</p>
              <strong>${money(item.final_line_price)}</strong>
            </div>
            <button type="button" data-cart-remove="${index + 1}" aria-label="Retirer">×</button>
          </div>`,
        )
        .join("");
      footer.hidden = false;
      const total = footer.querySelector("[data-cart-total]");
      if (total) total.textContent = money(cart.total_price);
    }
  };

  const fetchCart = async () => {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`);
    const cart = await response.json();
    renderCart(cart);
    return cart;
  };

  const addVariant = async (id, quantity = 1) => {
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity }] }),
    });
    if (!response.ok) throw new Error("Impossible d’ajouter ce produit.");
    await fetchCart();
    showToast();
    openCart();
  };

  document.addEventListener("click", async (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    if (target.closest("[data-cart-open]")) openCart();
    if (target.closest("[data-cart-close]")) closeCart();

    if (target.closest("[data-menu-open]")) {
      menu?.classList.add("is-open");
      menu?.setAttribute("aria-hidden", "false");
      lock();
    }
    if (target.closest("[data-menu-close]")) {
      menu?.classList.remove("is-open");
      menu?.setAttribute("aria-hidden", "true");
      unlock();
    }

    const quickAdd = target.closest("[data-quick-add]");
    if (quickAdd) {
      event.preventDefault();
      quickAdd.setAttribute("disabled", "");
      try {
        await addVariant(quickAdd.dataset.quickAdd);
      } catch (error) {
        window.alert(error.message);
      } finally {
        quickAdd.removeAttribute("disabled");
      }
    }

    const remove = target.closest("[data-cart-remove]");
    if (remove) {
      await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ line: Number(remove.dataset.cartRemove), quantity: 0 }),
      });
      await fetchCart();
    }
  });

  document.querySelectorAll("[data-product-root]").forEach((root) => {
    const json = root.querySelector("[data-product-json]");
    const form = root.querySelector("[data-product-form]");
    if (!json || !form) return;
    const variants = JSON.parse(json.textContent);
    const idInput = form.querySelector("[data-variant-id]");
    const addButton = form.querySelector("[data-add-to-cart]");
    const priceNodes = root.querySelectorAll("[data-product-price], [data-add-price]");
    const label = form.querySelector("[data-add-label]");
    const variantMediaJson = root.querySelector("[data-variant-media-json]");
    const variantMedia = variantMediaJson ? JSON.parse(variantMediaJson.textContent) : [];
    let selectVariantMedia = () => {};

    const updateVariant = () => {
      const values = [...form.querySelectorAll("[data-option-index]")].map(
        (group) => group.querySelector("[data-option-value].is-active")?.dataset.optionValue,
      );
      const variant = variants.find(
        (item) => item.options.every((option, index) => option === values[index]),
      );
      if (!variant) {
        addButton.disabled = true;
        label.textContent = "Indisponible";
        return;
      }
      idInput.value = variant.id;
      addButton.disabled = !variant.available;
      label.textContent = variant.available ? "Ajouter au panier" : "Épuisé";
      priceNodes.forEach((node) => (node.textContent = money(variant.price)));
      selectVariantMedia(variant.id);
      window.history.replaceState({}, "", `${window.location.pathname}?variant=${variant.id}`);
    };

    form.querySelectorAll("[data-option-value]").forEach((button) => {
      button.addEventListener("click", () => {
        button.parentElement
          .querySelectorAll("[data-option-value]")
          .forEach((item) => item.classList.remove("is-active"));
        button.classList.add("is-active");
        updateVariant();
      });
    });

    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      addButton.disabled = true;
      try {
        await addVariant(idInput.value);
      } catch (error) {
        window.alert(error.message);
      } finally {
        updateVariant();
      }
    });

    const track = root.querySelector("[data-gallery-track]");
    const slides = [...root.querySelectorAll("[data-gallery-slide]")];
    const dots = [...root.querySelectorAll("[data-gallery-dot]")];
    const videoToggle = root.querySelector("[data-product-video-toggle]");
    const videoToggleLabel = videoToggle?.querySelector("[data-video-toggle-label]");
    let active = 0;
    let timer;
    let activeImageSlide;

    const stopProductVideos = () => {
      slides.forEach((slide) => {
        const video = slide.querySelector("video");
        if (!video) return;
        video.pause();
        video.currentTime = 0;
      });
      videoToggle?.classList.remove("is-active");
      if (videoToggleLabel) {
        videoToggleLabel.textContent = videoToggle?.disabled
          ? "Vidéo indisponible"
          : "Voir en vidéo";
      }
    };

    selectVariantMedia = (variantId) => {
      stopProductVideos();
      const mediaId = variantMedia.find((item) => Number(item.id) === Number(variantId))?.mediaId;
      const colorGroup = form.querySelector(".sv-option-picker--color");
      const colorButtons = colorGroup
        ? [...colorGroup.querySelectorAll("[data-option-value]")]
        : [];
      const activeColor = colorGroup?.querySelector("[data-option-value].is-active");
      const normalize = (value = "") =>
        value
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase()
          .replace(/[^a-z0-9]/g, "");
      const colorName = normalize(activeColor?.dataset.optionValue);
      const imageSlides = slides.filter((slide) => slide.dataset.mediaType === "image");

      let selectedSlide = mediaId
        ? slides.find((slide) => Number(slide.dataset.mediaId) === Number(mediaId))
        : null;

      if (!selectedSlide && colorName) {
        selectedSlide = imageSlides.find((slide) =>
          normalize(slide.dataset.mediaAlt).includes(colorName),
        );
      }

      if (!selectedSlide && activeColor) {
        const colorIndex = colorButtons.indexOf(activeColor);
        selectedSlide = imageSlides[colorIndex] || slides[colorIndex];
      }

      selectedSlide ||= imageSlides[0] || slides[0];
      if (!selectedSlide) return;
      activeImageSlide = selectedSlide;

      slides.forEach((slide) => {
        const isSelected = slide === selectedSlide;
        slide.hidden = !isSelected;
        slide.classList.toggle("is-variant-active", isSelected);
      });
      active = slides.indexOf(selectedSlide);
      track.style.setProperty("--gallery-x", "0px");
    };
    selectVariantMedia(idInput.value);

    const closeProductVideo = () => {
      stopProductVideos();
      const selectedSlide = activeImageSlide || slides.find((slide) => slide.dataset.mediaType === "image");
      if (!selectedSlide) return;
      slides.forEach((slide) => {
        const isSelected = slide === selectedSlide;
        slide.hidden = !isSelected;
        slide.classList.toggle("is-variant-active", isSelected);
      });
    };

    videoToggle?.addEventListener("click", () => {
      if (videoToggle.disabled) return;
      if (videoToggle.classList.contains("is-active")) {
        closeProductVideo();
        return;
      }

      const videoSlide = slides.find(
        (slide) => Number(slide.dataset.mediaId) === Number(videoToggle.dataset.videoMediaId),
      );
      const video = videoSlide?.querySelector("video");
      if (!videoSlide || !video) return;

      slides.forEach((slide) => {
        const isSelected = slide === videoSlide;
        slide.hidden = !isSelected;
        slide.classList.toggle("is-variant-active", isSelected);
      });
      videoToggle.classList.add("is-active");
      if (videoToggleLabel) videoToggleLabel.textContent = "Fermer la vidéo";
      video.currentTime = 0;
      video.play().catch(() => {});
    });

    slides.forEach((slide) => {
      slide.querySelector("video")?.addEventListener("ended", closeProductVideo);
    });

    const showSlide = (next) => {
      if (!slides.length) return;
      active = (next + slides.length) % slides.length;
      track.style.setProperty("--gallery-x", `calc(${-100 * active}vw + ${8 * active}px)`);
      dots.forEach((dot, index) => dot.classList.toggle("is-active", index === active));
    };
    root.querySelector("[data-gallery-prev]")?.addEventListener("click", () => showSlide(active - 1));
    root.querySelector("[data-gallery-next]")?.addEventListener("click", () => showSlide(active + 1));
    dots.forEach((dot) =>
      dot.addEventListener("click", () => showSlide(Number(dot.dataset.galleryDot))),
    );

    if (
      root.dataset.autoRotate === "true" &&
      window.matchMedia("(max-width: 760px)").matches &&
      !window.matchMedia("(prefers-reduced-motion: reduce)").matches &&
      slides.filter((slide) => !slide.hidden).length > 1
    ) {
      timer = window.setInterval(
        () => showSlide(active + 1),
        Number(root.dataset.rotationSpeed) || 3000,
      );
      root.addEventListener("touchstart", () => window.clearInterval(timer), { once: true });
    }
  });

  document.querySelector("[data-sort-by]")?.addEventListener("change", (event) => {
    const url = new URL(window.location.href);
    url.searchParams.set("sort_by", event.target.value);
    window.location.href = url.toString();
  });
})();
